<template>
  <section class="bg-light-purple py-4 md:py-8">
    <form
      class="container relative lg:w-185 lg:max-w-185"
      @submit.prevent="search"
    >
      <label class="uppercase font-gt-america-extended text-tiny leading-3 md:text-smallest md:leading-4 md:-tracking-04-em">{{ $messages('help.labels.how_can_we_help_you') }}</label>
      <input
        ref="searchInput"
        v-model="searchQuery"
        type="text"
        class="form-input-v2 no-highlight outline-none h-9 w-full bg-transparent pr-7 border-t-0 border-r-0 border-l-0 border-b-2"
        :placeholder="$messages('help.labels.search_placeholder')"
        data-test-id="search-input"
        @focus="onFocus"
      >
      <button type="button" aria-label="Close icon" class="absolute right-4 bottom-1 no-highlight outline-none" @click="clearSearchQuery">
        <MajorityUiMajorityIcon icon="close" />
      </button>
    </form>
  </section>
</template>

<script>
export default {
  data () {
    return {
      searchQuery: ''
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.s) { this.searchQuery = this.$route.query.s }
  },
  methods: {
    search () {
      /*
      * If search query is empty, or contains only space, do not submit
      */
      if (this.searchQuery.trim() === '') { return }
      const route = this.$mRouter.getLocalRoute({ name: 'help-search', query: { s: this.searchQuery.trim() } })
      this.$router.push(route)
    },
    onFocus (evt) {
      if (this.$device.isMobile) {
        window.scrollTo({ top: evt.target.getBoundingClientRect().top - 60, behavior: 'smooth' })
      }
    },
    clearSearchQuery () {
      this.searchQuery = ''
      this.$refs.searchInput.focus()
    }
  }
}
</script>

<style lang="postcss" scoped>
.search-input {
  height: calc(100% - 4px);
}
</style>
